export const supportedLanguages = [
	{ code: 'en', name: 'English' },
	{ code: 'es', name: 'Español' },
]
